import CloseButton from "@/shared/ui/CloseButton";
import { HeaderTabsEnum } from "@/domains/faction/constants/headerTabsEnum";
import FactionTabs from "@/domains/faction/components/FactionTabs";

type Props = {
  src: string;
  headerSrc: string;
  headerList: string[];
  activeHeaderTab: HeaderTabsEnum;
  setActiveHeaderTab: (item: HeaderTabsEnum) => void;
  onClose: () => void;
};

export default function FactionHeader({
  src,
  headerSrc,
  headerList,
  activeHeaderTab,
  setActiveHeaderTab,
  onClose,
}: Props) {
  return (
    <div
      className="
        relative flex items-center min-h-[4.8125rem] px-6 overflow-hidden rounded-tl-4 rounded-tr-4 rounded-br-4
      "
      style={{ background: `url(${headerSrc}) no-repeat` }}
    >
      <div
        className="w-44 h-10.5 bg-cover bg-no-repeat bg-center"
        style={{ backgroundImage: `url(${src})` }}
      />
      <FactionTabs
        headerList={headerList}
        activeHeaderTab={activeHeaderTab}
        setActiveHeaderTab={setActiveHeaderTab}
        className="ml-auto"
      />

      <CloseButton className="ml-7.5 bg-[#232323] hover:bg-white/8" onClose={onClose} />
    </div>
  );
}
